import { chain, map } from 'fp-ts/lib/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import { listCodec } from './codec';
import { createAuthorizedGetRequest, decode, fetchApi, setQuery } from '../..';
import { encodeMeasurementsQuery, MeasurementsQuery } from './query';

const measurementsUrl = (id: number): string => `/v2/sensors/${id}/measurements`;

const MAX_MEASUREMENTS = 10000;

export const list = (id: number, query: MeasurementsQuery) => pipe(
  id,
  measurementsUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodeMeasurementsQuery(query))),
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const all = (id: number, start: Date, end: Date) => list(id, {
  from: start,
  to: end,
  page: 1,
  perPage: MAX_MEASUREMENTS,
});
